import { Data } from 'interfaces/ApolloResponse.interface'

export const isSingleDebtor = ({ debtors: { count } }: Data) => count === 1
